import { render, staticRenderFns } from "./wrapManage.vue?vue&type=template&id=d7c07bda&scoped=true"
import script from "./wrapManage.vue?vue&type=script&lang=js"
export * from "./wrapManage.vue?vue&type=script&lang=js"
import style0 from "./wrapManage.vue?vue&type=style&index=0&id=d7c07bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c07bda",
  null
  
)

export default component.exports